import moment from 'moment';
import {
  dateFormat, // DD.MM.YYYY
  dateFormatCompare, // DD-MM-YYYY
  LENGHT_SCHOOL_DAY, // - 30 min breacks
  START_YEAR, // dd.mm - curernt year
  END_1_SEMESTER, // dd.mm - curernt year
  START_2_SEMESTER, // dd.mm - +1 year
  END_YEAR, // dd.mm - +1 year
} from 'utils/moment/moment.constant';
import { isDatesBetween } from 'utils/moment/moment.utils';

export const getSchoolDaySecond = () => {
  const [sthours, stminutes] = LENGHT_SCHOOL_DAY.split(':');
  const fullSeconds = +sthours * 60 * 60 + +stminutes * 60;
  return fullSeconds;
};

export const getActualStartYear = () => {
  const [sday, smonth] = START_YEAR.split('-');
  const [s1day, s1month] = END_1_SEMESTER.split('-');
  const now = moment();
  const month = now.month() + 1;
  const day = now.date();
  const year =
    smonth >= month && s1month < month && (s1month == month && s1day <= day)
      ? now.year()
      : now.year() - 1;
  return START_YEAR + '-' + year;
};

export const getActualEndYear = () => {
  const first = getActualStartYear();
  const secondYear = moment(first, dateFormatCompare).year() + 1;
  return END_YEAR + '-' + secondYear;
};

export const getActualEndSemester1 = () => {
  const first = getActualStartYear();
  const secondYear = moment(first, dateFormatCompare).year() + 1;
  return END_YEAR + '-' + secondYear;
};

export const getActualStartSemester2 = () => {
  const first = getActualStartYear();
  const secondYear = moment(first, dateFormatCompare).year() + 1;
  return END_YEAR + '-' + secondYear;
};

export const getCurrentSemesterDates = () => {
  const now = moment();
  const d1 = getActualStartYear();
  const d2 = END_1_SEMESTER + '.' + moment(d1, dateFormatCompare).year();
  const s1 = START_2_SEMESTER + '.' + moment(s1, dateFormatCompare).year();
  const s2 = END_YEAR + '.' + moment(s1, dateFormatCompare).year();

  const isBetweenSem1 = isDatesBetween(
    moment(d1, dateFormatCompare).format(dateFormatCompare),
    moment(d2, dateFormatCompare).format(dateFormatCompare),
    moment(now, dateFormatCompare).format(dateFormatCompare),
  );
  const isBetweenSem2 = isDatesBetween(
    moment(s2, dateFormatCompare).format(dateFormatCompare),
    moment(s1, dateFormatCompare).format(dateFormatCompare),
    moment(now, dateFormatCompare).format(dateFormatCompare),
  );
  
  let startDate, endDate;
  if (isBetweenSem1) {
    startDate = moment(d1, dateFormatCompare).format(dateFormatCompare);
    endDate = moment(d2, dateFormatCompare).format(dateFormatCompare);
  } else if (isBetweenSem2) {
    startDate = moment(s2, dateFormatCompare).format(dateFormatCompare);
    endDate = moment(s1, dateFormatCompare).format(dateFormatCompare);
  }
  return (
    startDate &&
    endDate && {
      start: startDate,
      end: endDate,
    }
  );
};

